import React from "react";
export class BonusPobjednici extends React.Component {
    constructor(props) {
        super(props);
        this.state = { aktivni: null, prosli: null, ucitano: false, showAktivni: true, brojZapisa: 25, pokerSifre: ['ssopl', 'flop-utrka', 'bonus-izazovi','prvenstvo-hrvatske', 'turnir-prvaka', 'cash-liga'] }

        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);
        this.renderPobjednike = this.renderPobjednike.bind(this);
        this.renderPobjednikRow = this.renderPobjednikRow.bind(this);
        this.fetchData(this.props.sifra, this.props.najveciBrojSpinovaID, this.props.podebljajNajveciDobitakID, this.props.aktivno);
    }

    fetchData(bonusSifra, najveciBrojSpinovaID, podebljajNajveciDobitakID, aktivno) {
        this.props.showLoadingFn(true);

        let nadimak = null;
        if (this.props.userChecked && this.props.user)
            nadimak = this.props.user.nadimak;

        let promises = null;
        if (this.state.pokerSifre.indexOf(bonusSifra) >= 0)
            promises = Promise.all([casino.repos.pokerBonusPobjedniciRepo.list(bonusSifra, nadimak)]);
        else
            promises = Promise.all([casino.repos.casinoBonusPobjedniciRepo.list(bonusSifra, nadimak, najveciBrojSpinovaID, podebljajNajveciDobitakID, aktivno)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    componentWillUnmount() {
        if (this.dataPromises)
            this.dataPromises.cancel();
        this.props.showLoadingFn(false);
    }

    setData(data) {
        var [rezultati] = data;

        this.setState({
            aktivni: rezultati[0],
            prosli: rezultati[1],
            ucitano: true
        });

        this.props.showLoadingFn(false);
    }

    renderPobjednike(aktivni) {
        var dio = aktivni ? this.state.aktivni : this.state.prosli;
        //komponenta je i u pokeru pa jer EUR hardkodiran (ak se ova komponenta opce koristi ikad)
        return (
            <div>
                {this.state.ucitano && dio.najveciDobitak && <div>
                    <div className='najveciDobitakResult padding-sides-medium-2'>
                        <h2>Najveći dobitak</h2>
                        <table>
                            <tbody>
                                <tr>
                                    <td style={{ width: '50px' }}><img src='content/images/bonusi/img_2x.png?v2'></img></td>
                                    <td className={dio.najveciDobitak.dobitak ? "text text-1  text-bold" : "text text-1"}>{dio.najveciDobitak.igracIme}</td>
                                    {dio.najveciDobitak.dobitak && <td className='text-right text text-1  text-bold'> {casino.utils.numberWithCurrencyFromated(dio.najveciDobitak.dobitak, 'EUR')} </td>}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                }

                <table className="table-1 v2">
                    <thead>
                        <tr className="text-left text text-6">
                            <th>{this.state.pokerSifre.indexOf(this.props.sifra) >= 0 ? 'Plasman/Alias' : 'Plasman/Natjecatelj'} </th>
                            {aktivni && <th className="text-right"> {this.props.aktivniBodoviText ? this.props.aktivniBodoviText : 'Bodova'}</th>}
                            {!aktivni && <th className="text-right"> {this.props.prethodniBodoviText ? this.props.prethodniBodoviText : 'Bodova'}</th>}
                            <th className="text-right">Nagrada</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(!this.state.ucitano) && <tr className="horizontal-lines"><td colSpan="5"><span className="text text-1">Dohvaćanje rezultata...</span></td></tr>}

                        {this.state.ucitano && !dio.rezultati.length && <tr className="horizontal-lines"><td colSpan="5"><span className="text text-1">Trenutno nema rezultata...</span></td></tr>}
                        {dio && dio.rezultati && dio.rezultati.slice(0, this.state.brojZapisa).map((x) => this.renderPobjednikRow(x, dio.trenutniIgrac))}

                        {/* ako znamo plansman i nije u top 100 */}
                        {dio && dio.trenutniIgrac && dio.trenutniIgrac.plasman > this.state.brojZapisa && <tr className="horizontal-lines"><td></td></tr>}
                        {dio && dio.trenutniIgrac && dio.trenutniIgrac.plasman > this.state.brojZapisa && this.renderPobjednikRow(dio.trenutniIgrac, dio.trenutniIgrac)}

                        {/* ako neznamo plansman, onda nije u top 100 */}
                        {dio && dio.trenutniIgrac && dio.trenutniIgrac.plasman == 0 && !!dio.rezultati.length && <tr className="horizontal-lines"><td></td></tr>}
                        {dio && dio.trenutniIgrac && dio.trenutniIgrac.plasman == 0 && !!dio.rezultati.length && this.renderPobjednikRow(dio.trenutniIgrac, dio.trenutniIgrac)}
                    </tbody>
                </table>
                {dio && (dio.rezultati.length > this.state.brojZapisa) &&
                    <div className="text-center">
                        <button className="btn medium fill gray blue margin-top-small no-text-transform" onClick={() => this.setState({ brojZapisa: this.state.brojZapisa + 25 })}>
                            <span className="icon ico-chevron-down"></span> &nbsp; <span >Prikaži više</span>
                        </button>
                    </div>
                }
            </div>
        )
    }

    renderPobjednikRow(pobjednik, trenutniIgrac) {
        // komponenta se koristi i u pokeru pa je hardkodiran eur kod prikaza nagrade
        return (
            < tr key={pobjednik.alias} className={"horizontal-lines" + (pobjednik.plasman == (!!trenutniIgrac && trenutniIgrac.plasman) ? ' selected' : '')} >
                <td className="nowrap">
                    <span className="text text-8">{pobjednik.plasman != 0 ? pobjednik.plasman : '..'}. &nbsp;&nbsp;&nbsp; </span>
                    <span className="text text-1">
                        {this.state.pokerSifre.indexOf(this.props.sifra) >= 0 && pobjednik.alias}
                        {!(this.state.pokerSifre.indexOf(this.props.sifra) >= 0) && pobjednik.igracIme}
                    </span><br />
                </td>
                <td className="text text-1 text-right  text-bold ">{pobjednik.bodova}</td>
                
                <td className="text-right text text-7"> {!!pobjednik.ulaznica && <span className="text text-7"><span className="icon ico-listic-1 text-right text text-7"></span> {!!pobjednik.nagrada && '+'} </span>} {!!pobjednik.nagrada && casino.utils.numberWithCurrencyFromated(pobjednik.nagrada, 'EUR')}</td>
            </tr>
        )
    }

    render() {
        return (
            <div>
                {this.state.ucitano && !this.props.hidePrethodni &&
                    <div className="segment v2 margin-bottom-small padding-sides-medium-2">
                        <button className={"segment--btn" + (this.state.showAktivni ? ' selected' : '')}
                            onClick={() => this.setState({ showAktivni: true, brojZapisa: 25 })}>
                            {this.state.aktivni.datumOd && <span>{casino.utils.dateToShortDateString(new Date(this.state.aktivni.datumOd))} - {casino.utils.dateToShortDateString(new Date(this.state.aktivni.datumDo))}</span>}
                            {!this.state.aktivni.datumOd && <span>Trenutni rezultati</span>}
                        </button>
                        <button className={"segment--btn" + (!this.state.showAktivni ? ' selected' : '')}
                            onClick={() => this.setState({ showAktivni: false, brojZapisa: 25 })}>
                            <span>Prethodni rezultati</span>
                        </button>
                    </div>}
                <div className={this.state.showAktivni ? '' : 'hidden'}>
                    {this.renderPobjednike(true)}
                </div>
                <div className={!this.state.showAktivni ? '' : 'hidden'}>
                    {this.renderPobjednike(false)}
                </div>
            </div>
        )
    }
};

